import {Injectable} from '@angular/core';
import {Answer} from "../models/answer.model";
import {DialogService} from "../services/dialog.service";
import {ModalTemplates} from "../enums/modal-templates";
import {ModalTypes} from "../enums/modal-types";
import { SharedHelper } from './shared.helper';

@Injectable({
  providedIn: 'root'
})

export class DragDropHelper {
  constructor(
    private dialogService: DialogService,
    private sharedHelper: SharedHelper,
  ) {  }

  async getGlobalTexts(): Promise<any> {
    return await this.sharedHelper.getGlobalTexts().toPromise();
  }

  onDragStart(event: DragEvent, answer: Answer) {
    event.dataTransfer?.setData('text/plain', JSON.stringify(answer));
  }

  async onDrop(event: DragEvent, zones: Answer[], index: number) {
    event.preventDefault();
    const item = event.dataTransfer?.getData('text/plain');

    if (item){
      try {
        // Try to parse the item and If parsing is successful, assign it to the zone
        zones[index] = JSON.parse(item);
      } catch (error) {
        // If an error is thrown, the item is not a valid JSON. We call a modal alert
        const globalTexts = await this.getGlobalTexts();
        this.dialogService.confirmThis('', globalTexts.modals?.action_not_allowed?.message, ModalTypes.Alert, ModalTemplates.Default, () => {}, () => {});

        //console.error('Invalid JSON:', item);
      }
    }
    //if (item) zones[index] = JSON.parse(item);
    zones[index].is_drag_over = false;
  }

  onDragOver(event: DragEvent, zones: Answer[], index: number) {
    event.preventDefault(); // Always allow drop
    zones[index].is_drag_over = true;
  }

  onDragLeave(event: DragEvent, zones: Answer[], index: number) {
    zones[index].is_drag_over = false;
  }



}
